var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"team-card"},[_c('div',[_c('span',[_c('img',{staticClass:"team-img",attrs:{"src":_vm.img}})])]),_c('h3',[_vm._v(_vm._s(_vm.name))]),_c('p',[_vm._v(_vm._s(_vm.role))]),_c('a',{staticStyle:{"display":"none"},attrs:{"href":"#","aria-label":"LinkedIn profile"}},[_vm._v("in")])])
}
var staticRenderFns = []

export { render, staticRenderFns }